
<div>
    <div class="en-tete">
        <div class="d-flex justify-content-between">
            <p>{{title}} </p>
            <mat-icon style="cursor: pointer;" (click)="fermer()" mat-raised-button>close</mat-icon>
        </div>
    </div>
    <div class="content">
        <div class="body">
            <app-generic-dialog [tab]="tab"></app-generic-dialog>
        </div>
    </div>
</div>



